import axios from "axios";

export function peticionInforme(message) {
  return axios.post('/api/informes', {message: message})
}

export function clearChat(){
  return axios.delete('/api/chat')
}